/* eslint-disable no-restricted-syntax, guard-for-in */

import Vue from 'vue';

Vue.component('case-hero-video', {

    data() {
        return {
        };
    },

    /**
     * Mount this stuff.
     */
    mounted() {
        const lazyVideos = [].slice.call(document.querySelectorAll('video.lazy'));
        let lazyVideoObserver = null;

        if ('IntersectionObserver' in window) {
            lazyVideoObserver = new IntersectionObserver((entries, observer) => {
                entries.forEach((video) => {
                    if (video.isIntersecting) {
                        for (const source in video.target.children) {
                            const videoSource = video.target.children[source];
                            if (typeof videoSource.tagName === 'string' && videoSource.tagName === 'SOURCE') {
                                videoSource.src = videoSource.dataset.src;
                            }
                        }

                        video.target.load();
                        video.target.classList.remove('lazy');
                        lazyVideoObserver.unobserve(video.target);
                    }
                });
            });
        }

        lazyVideos.forEach((lazyVideo) => {
            if (lazyVideoObserver) {
                lazyVideoObserver.observe(lazyVideo);
            }
        });
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {

    },
});
